import ActionResult from 'app/src/engine/action-results/ActionResult';
import MovableItem from 'app/src/engine/movable-items/MovableItem';

export default class MovableItemActionResult extends ActionResult {
	private _movableItem: MovableItem;
	get movableItem(): MovableItem {
		return this._movableItem;
	}

	constructor(movableItem: MovableItem) {
		super();

		this._movableItem = movableItem;
	}
}
